const io = require("../libs/socket.io.slim.js");
const Notification = require("./components/notification.js");
const { url: socketUrl } = require("./config.js");

const _socket = io(socketUrl, { transports: ["websocket"] });
const { guidGenerator, getChatURL, getParameterByName } = require("./utils");
let session = getChatURL() || getParameterByName("session") || "";
let reconnected = false;

let _reload = function() {
  setTimeout(function() {
    window.location = window.location;
  }, 100);
};

_socket.on("connect", function(socket) {
  _socket.id = _socket.io.engine.id;

  const w = window.innerWidth;
  const h = window.innerHeight;
  if (reconnected) {
    reconnected = false;
    return;
  }
  _socket.emit("join", {
    id: session,
    socket: _socket.id,
    mode: (getParameterByName("from") || 'browser'),
    kioskMode: getParameterByName("kioskMode"),
    browser: {
      cookieEnabled: navigator.cookieEnabled,
      userAgent: navigator.userAgent,
      pixel: Math.max(window.devicePixelRatio || 1, 1),
      window: {
        height: h,
        width: w,
      },
    }
    //sessionToken: token //AR: don't know if this
  });
});

_socket.on("reload", function(err) {
  _reload();
});

_socket.on("reconnect", function(err) {
  Notification.clear();
  reconnected = true;
});

_socket.on("reconnecting", function(attempt) {
  console.log("reconnecting...", attempt);
  Notification.show("Connection lost. Reconnecting...", "warning");
});

_socket.on("reconnect_failed", function(err) {
  console.log("reconnect_failed", err);
});

_socket.on("connect_error", function(err) {
  // console.log(err)
});

_socket.on("disconnect", function(reason) {
  Notification.show("Disconnected", "error");
  console.log("disconnect", reason);
});

// AR: this code is need to toggle closing / switching on mobile apps
// setTimeout(function() {

//   // Add a listener to detect visibility change state
//   document.addEventListener(
//     visibilityChange,
//     function() {
//       console.log(document[state]);

//       if (document[state] == "visible") {
//         if (isMobile() && _shouldDisconnect) {
//           if (_visibilityTimer) clearTimeout(_visibilityTimer);

//           _visibilityTimer = setTimeout(function() {
//             //_SOCKET.connect(_onConnection,_onOnline,_onConnectionError);
//             window.location = window.location;
//           }, 500);
//         }
//       } else if (document[state] == "hidden") {
//         if (isMobile() && _shouldDisconnect) {
//           //disconnect on mobile
//           if (_visibilityTimer) clearTimeout(_visibilityTimer);

//           _visibilityTimer = setTimeout(function() {
//             _socket.disconnect(function() {
//               _onDisconnect();
//             });
//           }, 500);
//         }
//       } else {
//       }
//     },
//     false
//   );
// }, 100);

module.exports = {
  on: function(event, callback) {
    _socket.on(event, callback);
  },
  emit: function(channel, message, callback) {
    let signature = guidGenerator();

    var de = document.documentElement,
      root = de.getElementsByTagName("body")[0],
      w = window.innerWidth || de.clientWidth || rte.clientWidth,
      h = window.innerHeight || de.clientHeight || rte.clientHeight;

    let nowdt = new Date();
    message.session = session;
    message.signature = signature;
    message.mode  = (getParameterByName("from") || 'browser');
    message.localdatetime = nowdt.toLocaleString("en-US");
    message.localdate = nowdt.toLocaleDateString("en-US");
    message.localtime = nowdt.toLocaleTimeString("en-US");
    message.browser = {
      cookieEnabled: navigator.cookieEnabled,
      userAgent: navigator.userAgent,
      pixel: Math.max(window.devicePixelRatio || 1, 1),
      window: {
        height: h,
        width: w,
      },
    };

    message.sender = window.HealthNote_User || {
      id: session,
      fullname: "",
      profileURL: "",
      sessionToken: "",
      socket: _socket.id,
    };
    // message.eHash = "0aed...";

    function reconnectWithBackoff(attempts, delay) {
        if (attempts === 0) {
          console.error('Failed to reconnect after 3 attempts.');
          return _reload();
        }

        if (!_socket.connected) {
          setTimeout(() => {
            console.log(`Retrying connection, attempts left: ${attempts}`);
            if (_socket.connected) {
              _socket.emit(channel, message);
            } else {
              reconnectWithBackoff(attempts - 1, delay * 2);
            }
          }, delay);
        } else {
          _socket.emit(channel, message);
        }
      }

      reconnectWithBackoff(5, 1000); // 5 attempts with initial delay of 1 second
  },
};
